import { getDirectives, valueMatchesCriteria } from '@graphql-tools/utils';
import FilterObjectFields from './FilterObjectFields';
var RemoveObjectFieldsWithDirective = /** @class */ (function () {
    function RemoveObjectFieldsWithDirective(directiveName, args) {
        if (args === void 0) { args = {}; }
        this.directiveName = directiveName;
        this.args = args;
    }
    RemoveObjectFieldsWithDirective.prototype.transformSchema = function (originalSchema) {
        var _this = this;
        var transformer = new FilterObjectFields(function (_typeName, _fieldName, fieldConfig) {
            var valueMap = getDirectives(originalSchema, fieldConfig);
            return !Object.keys(valueMap).some(function (directiveName) {
                return valueMatchesCriteria(directiveName, _this.directiveName) &&
                    ((Array.isArray(valueMap[directiveName]) &&
                        valueMap[directiveName].some(function (value) { return valueMatchesCriteria(value, _this.args); })) ||
                        valueMatchesCriteria(valueMap[directiveName], _this.args));
            });
        });
        return transformer.transformSchema(originalSchema);
    };
    return RemoveObjectFieldsWithDirective;
}());
export default RemoveObjectFieldsWithDirective;
//# sourceMappingURL=RemoveObjectFieldsWithDirective.js.map